module.exports = __webpack_public_path__ + "static/media/limon.4e9624ee.png";